import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

export type ReturnDetailRes = {
  acceptList: { baseUrl: string; id: string; name: string; url: string }[]
  address: string
  applyMan: string
  applyTime: string
  consignee: string
  createTime: string
  customer: string
  filingNo: string
  id: string
  invoicingState: string
  mobile: string
  orderNo: string
  orderId: string
  orderReturnNo: string
  orderReturnState: string
  orderState: string
  platform: string
  price: number
  productList: {
    brand: string
    code: string
    model: string
    name: string
    price: number
    reCount: number
    unit: string
  }[]
  progress: string
  refundPrice: number
  rejectReason: string
  returnMobile: string
  returnReason: string
  returnTime: string
  settlePrice: number
  thisReturnPrice: number
}

//  电商供应商订单-退货单详情
export const GET_RETURN_DETAIL = (params: { orderReturnId: string }) =>
  GET<ReturnDetailRes>(`${HTTP}/return/getOrderReturnDetail`, params)

//  电商供应商订单-取消单详情
export const GET_CANCEL_DETAIL = (params: { orderReturnId: string }) =>
  GET(`${HTTP}/return/getOrderCancelDetail`, params)

//  供应商订单-退货单详情
export const GET_SUPPLIER_RETURN_DETAIL = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrderReturn/getSupplierOrderReturnDetail`, params)

//  供应商订单-取消单
export const GET_SUPPLIER_CANCEL_DETAIL = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrderReturn/getSupplierOrderCancelDetail`, params)

//  获取报备单详情
export const GET_FILINGDETAIL = (params: { filingId: string }) =>
  GET(`${HTTP}/filing/getFilingDetail`, params)

//  退货单审核
export const CHECK_ORDER_RETURN = (params: {
  isPass: string
  orderReturnId: string
  reason?: string
}) => POST(`${HTTP}/return/checkOrderReturn`, params, 'application/json')

//  取消单审核
export const CHECK_ORDER_CANCEL = (params: {
  isPass: string
  orderReturnId: string
  reason?: string
}) => POST(`${HTTP}/return/checkCancelReturn`, params, 'application/json')

export const ORDER_COMPLETE = (params: { id: string }) =>
  POST(`${HTTP}/return/OrderReturnComplete`, params, 'application/json')
import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

export type ReturnDetailRes = {
  acceptList: { baseUrl: string; id: string; name: string; url: string }[]
  address: string
  applyMan: string
  applyTime: string
  consignee: string
  createTime: string
  customer: string
  filingNo: string
  id: string
  invoicingState: string
  mobile: string
  orderNo: string
  orderId: string
  orderReturnNo: string
  orderReturnState: string
  orderState: string
  platform: string
  price: number
  productList: {
    brand: string
    code: string
    model: string
    name: string
    price: number
    reCount: number
    unit: string
  }[]
  progress: string
  refundPrice: number
  rejectReason: string
  returnMobile: string
  returnReason: string
  returnTime: string
  settlePrice: number
  thisReturnPrice: number
}

//  电商供应商订单-退货单详情
export const GET_RETURN_DETAIL = (params: { orderReturnId: string }) =>
  GET<ReturnDetailRes>(`${HTTP}/return/getOrderReturnDetail`, params)

//  电商供应商订单-取消单详情
export const GET_CANCEL_DETAIL = (params: { orderReturnId: string }) =>
  GET(`${HTTP}/return/getOrderCancelDetail`, params)

//  供应商订单-退货单详情
export const GET_SUPPLIER_RETURN_DETAIL = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrderReturn/getSupplierOrderReturnDetail`, params)

//  供应商订单-取消单
export const GET_SUPPLIER_CANCEL_DETAIL = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrderReturn/getSupplierOrderCancelDetail`, params)

//  获取报备单详情
export const GET_FILINGDETAIL = (params: { filingId: string }) =>
  GET(`${HTTP}/filing/getFilingDetail`, params)

//  退货单审核
export const CHECK_ORDER_RETURN = (params: {
  isPass: string
  orderReturnId: string
  reason?: string
}) => POST(`${HTTP}/return/checkOrderReturn`, params, 'application/json')

//  取消单审核
export const CHECK_ORDER_CANCEL = (params: {
  isPass: string
  orderReturnId: string
  reason?: string
}) => POST(`${HTTP}/return/checkCancelReturn`, params, 'application/json')

export const ORDER_COMPLETE = (params: { id: string }) =>
  POST(`${HTTP}/return/OrderReturnComplete`, params, 'application/json')
